if (!customElements.get('no-preference')) {
    class FrameFinderNopreference extends HTMLElement {
        connectedCallback() {
            const noPrefButton = this.querySelector('.btn-no-pref');
            if (noPrefButton) {
                noPrefButton.addEventListener('click', () => this.handleNoPreference());
            }
        }

        handleNoPreference() {
            const currentSection = this.closest('frame-finder-main');
            if (currentSection) {
                // Rimuovi le selezioni della sezione corrente
                const selectedInputs = currentSection.querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked');
                selectedInputs.forEach(input => {
                    input.checked = false; // Deseleziona l'opzione
                });

                // Elimina la risposta corrente dai selected_answers
                const sectionIndex = currentSection.getAttribute('data-index');
                let selectedAnswers = JSON.parse(localStorage.getItem('selected_answers')) || {};
                delete selectedAnswers[sectionIndex]; // Rimuovi la selezione corrente
                localStorage.setItem('selected_answers', JSON.stringify(selectedAnswers));

                // Aggiorna subito l'URL
                this.updateUrl();

                // Nasconde la sezione corrente
                currentSection.style.display = 'none';
                currentSection.classList.remove('active');
            }

            // Passa alla sezione successiva
            const nextIndex = parseInt(currentSection.getAttribute('data-index')) + 1;
            const nextSection = document.querySelector(`frame-finder-main[data-index="${nextIndex}"]`);

            if (nextSection) {
                // Mostra la sezione successiva
                nextSection.style.display = 'block';
                nextSection.classList.add('active');
            } else {
                // Se è l'ultima sezione, aggiorna l'URL con le risposte selezionate finora
                this.updateUrl();
            }
        }

        updateUrl() {
            const selectedAnswers = JSON.parse(localStorage.getItem('selected_answers')) || {};
            let currentUrlParts = [];

            // Crea l'URL solo con le risposte effettive (non vuote)
            for (const index in selectedAnswers) {
                if (selectedAnswers[index] && selectedAnswers[index] !== "") { // Aggiunge solo risposte non vuote
                    currentUrlParts.push(selectedAnswers[index]);
                }
            }

            const currentUrl = currentUrlParts.join('&'); // Combina con "&" solo le risposte valide
            localStorage.setItem('current_url', currentUrl); // Salva l'URL aggiornato

        }
    }

    customElements.define('no-preference', FrameFinderNopreference);
}